// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_98-0";